import { render } from "./Scroll.vue?vue&type=template&id=7aec0b9c"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrewderse/Documents/repos/gal-scroll-viewer-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__